import { render, staticRenderFns } from "./CompanySidebar.vue?vue&type=template&id=64480d09"
import script from "./CompanySidebar.vue?vue&type=script&lang=js"
export * from "./CompanySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports